import {
  ImageAdPlacementWithImageAsBackground,
  ImageAdPlacementWithRating,
  ImageAdPlacementWithCTA,
  ImageAdPlacementWithPlayIcon,
} from './image-ad-placement';

import {
  ImageAdWithLogoPlacementNoImage,
  ImageAdWithLogoPlacementWithImage,
} from './image-ad-with-logo-placement';

import { TextAdPlacement } from './text-ad-placement';

import { CustomizeUAPPlacementType as CPT } from './ad-placement-type';

const PlacementType2Component = {
  [CPT.ImageAdPlacementWithCTA]: ImageAdPlacementWithCTA,
  [CPT.ImageAdPlacementWithImageAsBackground]: ImageAdPlacementWithImageAsBackground,
  [CPT.ImageAdPlacementWithPlayIcon]: ImageAdPlacementWithPlayIcon,
  [CPT.ImageAdPlacementWithRating]: ImageAdPlacementWithRating,

  [CPT.ImageAdWithLogoPlacementNoImage]: ImageAdWithLogoPlacementNoImage,
  [CPT.ImageAdWithLogoPlacementWithImage]: ImageAdWithLogoPlacementWithImage,

  [CPT.TextAdPlacement]: TextAdPlacement,
};

export const getAdPlacementComponent = placementType =>
  PlacementType2Component[placementType];
